import React, { Component } from 'react';
import { SearchTable } from '../Paginator/SearchTable';

class Search extends Component {
  render() {
    return (
          <SearchTable {...this.props}/>
    )
  }
}

export { Search };
